// @flow

import React from 'react';
import { connect } from 'react-redux';
import ActiveItem from '../activeItem';
import {
  getMileageLabel,
  getMonthText,
  getYearText,
  getLongMileageLabel,
  getPerText,
} from '../../../../../../store/configuratorSettings/selectors';
import { getCartMileageDisplayType } from '../../../../../../store/productTypeSettings/selectors';
import type { Mileage } from '../../../../../../types/pdb';
import { displayMileage } from '../../../../../../helpers';
import { DISPLAY_MONTHLY } from '../../../../../../store/productTypeSettings/constants';

type OwnProps = {|
  active: Mileage,
  price: number,
  pdbId?: ?string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  label: string,
  mileageDisplayType: string,
  mileageLabel: string,
  mileadgeLabelMonth: string,
  mileadgeLabelYear: string,
  mileadgeLabelPer: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ActiveMileage = ({
  active,
  price,
  label,
  mileageDisplayType,
  mileageLabel,
  mileadgeLabelMonth,
  mileadgeLabelYear,
  mileadgeLabelPer,
  ...props
}: Props) => (
  <ActiveItem
    type={label}
    title={
      active.mileageAsNumber
        ? displayMileage(active.mileageAsNumber, `${mileageLabel} ${mileadgeLabelPer} ${mileageDisplayType === DISPLAY_MONTHLY ? mileadgeLabelMonth : mileadgeLabelYear}`, mileageDisplayType)
        : active.name
    }
    price={price}
    {...props}
  />
);

ActiveMileage.defaultProps = {
  pdbId: null,
};

const mapStateToProps = (state, { pdbId }: OwnProps): StateProps => ({
  label: getMileageLabel(state),
  mileageDisplayType: getCartMileageDisplayType(state, pdbId),
  mileageLabel: getLongMileageLabel(state),
  mileadgeLabelMonth: getMonthText(state),
  mileadgeLabelYear: getYearText(state),
  mileadgeLabelPer: getPerText(state),
});

ActiveMileage.defaultProps = {
  pdbId: '',
};

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ActiveMileage);
